import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
Vue.use(VeeValidate)
Validator.extend('laserId', {
  validate: value => /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{12,12}$/.test(value)
})
Validator.extend('email', {
  validate: value => /^[A-Za-z0-9\u4e00-\u9fa5._-]+@[a-zA-Z0-9_-]+([.]+[a-zA-Z0-9_-]+)+$/.test(value)
})
